module.exports = __webpack_public_path__ + "img/minecraft.133e49e8.png";